import {MouseEvent, ReactNode} from 'react';
import {Link} from 'react-router-dom';
import {FileData, getFileURL, getShareableFileURL} from '../../../app/pages/documents/api';
import {CommonFile} from '../../../app/pages/admin/documents/api';
import {useDownloadFile} from '../Hooks/DocumentHooks';

interface DocumentDownloadLinkProps {
  file: FileData | CommonFile;
  className?: string;
  ariaLabel?: string;
  children: ReactNode;
}

/**
 * Vrai lien vers la page de téléchargement (ouvrable dans un nouvel onglet, copiable, partageable).
 * Un clic simple télécharge directement sans quitter la page.
 */
const DocumentDownloadLink = ({
  file,
  className,
  ariaLabel,
  children,
}: DocumentDownloadLinkProps): JSX.Element => {
  const {mutate} = useDownloadFile();

  const handleClick = (event: MouseEvent<HTMLAnchorElement>): void => {
    // Ctrl/Cmd/Shift/Alt-clic et clic molette : comportement natif du lien.
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
      return;
    }
    event.preventDefault();
    mutate(getFileURL(file));
  };

  return (
    <Link
      to={getShareableFileURL(file)}
      className={className}
      aria-label={ariaLabel}
      onClick={handleClick}
    >
      {children}
    </Link>
  );
};

export default DocumentDownloadLink;
